import React from 'react';
import { Link } from 'react-router-dom'; // import ReactHtmlParser from 'react-html-parser';

var MarkerPopover = function MarkerPopover(props) {
  var store = props.store;
  var showroomPath = false;

  if (store.showroom) {
    var _store$showroom, _store$showroom$title, _store$showroom$title2, _store$showroom2;

    showroomPath = store === null || store === void 0 ? void 0 : (_store$showroom = store.showroom) === null || _store$showroom === void 0 ? void 0 : (_store$showroom$title = _store$showroom.title) === null || _store$showroom$title === void 0 ? void 0 : (_store$showroom$title2 = _store$showroom$title.replace(/\s+/g, '-')) === null || _store$showroom$title2 === void 0 ? void 0 : _store$showroom$title2.toLowerCase();
    showroomPath = "/showroom-tours/".concat(showroomPath + '-id_' + (store === null || store === void 0 ? void 0 : (_store$showroom2 = store.showroom) === null || _store$showroom2 === void 0 ? void 0 : _store$showroom2.showroom_id));
  }

  return React.createElement("div", {
    className: "marker-popover"
  }, React.createElement("h5", null, store.name), React.createElement("p", null, store.street), React.createElement("p", null, store.city, ", ", store.zip), React.createElement("p", null, store.country), React.createElement("div", {
    className: "store-hours-wrapper"
  }), React.createElement("div", {
    className: 'showroom-website-content-wrapper'
  }, store.website ? React.createElement("div", {
    className: 'website-content'
  }, React.createElement("a", {
    href: store.website.includes('http') ? store.website : 'http://' + store.website,
    target: '_blank',
    rel: "noopener",
    className: 'link-elaine'
  }, React.createElement("p", {
    className: "link-green"
  }, "Visit Our Website"))) : React.createElement(React.Fragment, null), showroomPath ? React.createElement(Link, {
    to: showroomPath
  }, React.createElement("p", {
    className: "link-green"
  }, "Virtual Showroom")) : React.createElement(React.Fragment, null)));
};

export default MarkerPopover;